import axios from 'axios'
const state = {
  supplierProducts: [],
}
const mutations = {
  setSupplierProducts (state, data) {
    // console.log(data)
    state.supplierProducts = data
  },
}
const actions = {
  getOptionsSpplierProduct () {},
  getAllSupplierProducts ({ commit }) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/supplier-products/`)
      .then(({ data }) => {
        commit('setSupplierProducts', data)
      })
      .catch(e => console.log(e))
  },
  searchSupplierProducts ({ commit }, credentials) {
    return axios
      .get(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/supplier-products/${credentials}`,
      )
      .then(async ({ data }) => {
        const dataProducts = data
        await axios
          .options(
            `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/supplier-products/`,
          )
          .then(({ data }) => {
            // console.log(dataProducts)
            dataProducts.options = data.actions.POST
            commit('setSupplierProducts', dataProducts)
          })
      })
      .catch(e => console.log(e))
  },
  addSupplierProduct ({}, credentials) {
    return axios
      .post(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/supplier-products/`,
        credentials,
      )
      .then(() => {
        // dispatch('getAllSupplierProducts')
      })
      .catch(e => {
        console.log(e)
      })
  },
  updateSupplierProduct ({}, credentials) {
    return axios
      .put(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/supplier-products/${credentials.id}/`,
        credentials,
      )
      .then(() => {
        // dispatch('getAllSupplierProducts')
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteSupplierProduct ({}, credentials) {
    return axios
      .delete(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/supplier-products/${credentials}/`,
      )
      .then(() => {
        // dispatch('getAllSupplierProducts')
      })
      .catch(e => {
        console.log(e)
      })
  },
}

export default {
  state,
  mutations,
  actions,
}
